import { zonedDate, zonedWallClock } from "../time-zone-rules";

// Both read tzdata 2026e's changes over the runtime's data (lib/time-zone-rules.ts).
export function todayDateISOInTimeZone(timezone: string, now: Date): string {
  return zonedDate(now.getTime(), timezone);
}

export function localHourInTimeZone(timezone: string, now: Date): number {
  return zonedWallClock(now.getTime(), timezone).hour;
}
